import { render, staticRenderFns } from "./FlagRecord.vue?vue&type=template&id=d04df22e&"
import script from "./FlagRecord.vue?vue&type=script&lang=js&"
export * from "./FlagRecord.vue?vue&type=script&lang=js&"
import style0 from "./FlagRecord.vue?vue&type=style&index=0&id=d04df22e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports